import { formatNumber } from '@if/core/utils'
import { Box, Grid, InputAdornment, TextField, Typography } from '@mui/material'
import { Merchant } from '@src/data/types/Merchant'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

interface MerchantRatesPanelProps {
  merchant: Merchant
}

const MerchantRatesPanel: FC<MerchantRatesPanelProps> = ({ merchant }) => {
  const { t } = useTranslation()

  const adminFeeCustomer = merchant.merchantBaseRates?.lenderFeeRate ?? 0
  const adminFeeMerchant = merchant.merchantBaseRates?.adminFeeMerchant ?? 0
  const customerRateModifier = merchant.merchantBaseRates?.interestRateModifier ?? 0

  return (
    <Box>
      <Typography variant="h6" gutterBottom paddingBottom={2}>
        {t('merchant.ratesAndFees.title')}
      </Typography>
      <Grid container spacing={4}>
        <Grid
          size={{
            xs: 12,
            sm: 4,
          }}
        >
          <TextField
            label={t(`merchant.ratesAndFees.adminFeeCustomer`)}
            value={formatNumber(adminFeeCustomer)}
            fullWidth
            disabled
            slotProps={{
              input: {
                endAdornment: <InputAdornment position="end">%</InputAdornment>,
              },
            }}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            sm: 4,
          }}
        >
          <TextField
            label={t(`merchant.ratesAndFees.adminFeeMerchant`)}
            value={formatNumber(adminFeeMerchant)}
            fullWidth
            disabled
            slotProps={{
              input: {
                endAdornment: <InputAdornment position="end">%</InputAdornment>,
              },
            }}
          />
        </Grid>
        <Grid
          size={{
            xs: 12,
            sm: 4,
          }}
        >
          <TextField
            label={t(`merchant.ratesAndFees.customerRateModifier`)}
            value={formatNumber(customerRateModifier)}
            fullWidth
            disabled
            slotProps={{
              input: {
                endAdornment: <InputAdornment position="end">%</InputAdornment>,
              },
            }}
          />
        </Grid>
      </Grid>
    </Box>
  )
}

export default MerchantRatesPanel
